import { axiosPost } from 'shared/api/axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import { AxiosError } from 'axios'
import Store from 'redux/Store'
import { setMessage } from 'redux/actions'

interface submitFormProps {
  id: string | undefined
  setShowOverlay: Function
  setRefreshCsvCount: Function
}

const refreshCsv = async (props: submitFormProps) => {
  props.setShowOverlay(true)

  let response: any = false

  const formData = { payment_detail_id: props.id }

  const catchFunc = (err: AxiosError) => {
    const message = err?.response?.data?.message ?? 'An error has occurred'
    displayGenError({ setShowOverlay: props.setShowOverlay, message: message })
  }

  response = await axiosPost(
    apiUrls.paymentDetails + '/' + apiUrls.actionRefreshCsv,
    formData,
    catchFunc,
  )

  if (response?.status === 200) {
    Store.dispatch(setMessage('CSV file data refresh scheduled.', 'success', 'instant'))
    props.setRefreshCsvCount((prevValue) => prevValue + 1)
  }
  props.setShowOverlay(false)
}

export default refreshCsv
